import ReactSelect, { Props } from 'react-select';

import { SelectLabel, ISelectLabelProps } from './SelectLabel';
import { styles } from './styles/styles';

export interface IOptionType {
  label: string;
  value: string;
}
export type ISelectProps = ISelectLabelProps & Props;

export const Select = ({
  id,
  label,
  containerClassname = '',
  labelClassName = '',
  ...rest
}: ISelectProps) => (
  <SelectLabel
    id={id}
    label={label}
    containerClassname={containerClassname}
    labelClassName={labelClassName}
  >
    <ReactSelect id={id} instanceId={id} styles={styles} {...rest} />
  </SelectLabel>
);
